// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/documentUpload/components/DocumentUploadModal.scss
// module id = 1966
// module chunks = 0